/* unplugin-vue-components disabled */import script from "./merchant.vue?vue&type=script&setup=true&name=merchant&lang=js"
export * from "./merchant.vue?vue&type=script&setup=true&name=merchant&lang=js"

const __exports__ = script;

export default __exports__